import { Button } from "components";
import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

export const AddToHomeScreen: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] =
    useState<BeforeInstallPromptEvent | null>(null);
  const [showPopover, setShowPopover] = useState<boolean>(false);
  const [isInstalling, setIsInstalling] = useState<boolean>(false);

  const oneMonthInMs = 30 * 24 * 60 * 60 * 1000; // show just one month

  useEffect(() => {
    const lastPromptTime = localStorage.getItem("install-popover-last-date");
    const isAppInstalled = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    const currentTime = new Date().getTime();

    if (
      !isAppInstalled &&
      (!lastPromptTime || currentTime - Number(lastPromptTime) > oneMonthInMs)
    ) {
      const handleBeforeInstallPrompt = (e: Event) => {
        e.preventDefault();
        const event = e as BeforeInstallPromptEvent;
        setDeferredPrompt(event);
        setShowPopover(true);
      };

      window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

      return () => {
        window.removeEventListener(
          "beforeinstallprompt",
          handleBeforeInstallPrompt
        );
      };
    }
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      setIsInstalling(true);
      await deferredPrompt.prompt();
      setDeferredPrompt(null);
      setShowPopover(false);
      setIsInstalling(false);

      localStorage.setItem(
        "install-popover-last-date",
        new Date().getTime().toString()
      );
    }
  };

  const handleCancel = () => {
    setShowPopover(false);
    localStorage.setItem(
      "install-popover-last-date",
      new Date().getTime().toString()
    );
  };

  if (!showPopover || isInstalling) return null;

  return (
    <Fade
      triggerOnce
      delay={300}
      direction="up"
      className="card position-fixed bottom-0 end-0 m-3 shadow-lg rounded-3"
      style={{ width: "14rem", zIndex: 100 }}
    >
      <div className="card-body">
        <h5 className="card-title h5">نصب وب اپ سنجاب</h5>
        <small className="text-muted">
          برای نصب برنامه بر روی دستگاه خود، اینجا را کلیک کنید
        </small>
        <div className="d-flex gap-2 mt-2">
          <Button variant="outlined" onClick={handleCancel}>
            بستن
          </Button>
          <Button onClick={handleInstallClick} disabled={isInstalling}>
            {isInstalling ? "در حال نصب..." : "نصب"}
          </Button>
        </div>
      </div>
    </Fade>
  );
};
